import type { QuickSearchHierarchyResult } from '@/types/searchTypes'
import { VpDivider } from '@vtmn-play/react/headless'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import { getQuickSearchResultLabel } from '@/components/QuickSearch/quickSearchLabels'
import { HighlightMatch } from './HighlightMatch'

interface HierarchyItemProps {
  query: string
  result: QuickSearchHierarchyResult
  onClick: () => void
  displayMode?: 'default' | 'inline-pipe'
  displayType?: boolean
  isLastItem?: boolean
}

export function HierarchyItem({
  query,
  result,
  onClick,
  displayMode = 'default',
  displayType = false,
  isLastItem = false,
}: Readonly<HierarchyItemProps>) {
  const { t, i18n } = useTranslation()
  const label = getQuickSearchResultLabel(result.labels, i18n.language)

  return (
    <>
      <button
        type="button"
        className={clsx('quick-search__list-item', {
          'quick-search__list-item--inline-pipe': displayMode === 'inline-pipe',
          'quick-search__list-item--with-separator': displayMode === 'inline-pipe' && !isLastItem,
        })}
        onClick={onClick}
      >
        <div className="quick-search__list-item-main">
          {result.code && (
            <span className="quick-search__list-item-code">
              {result.code}
              {' '}
              -
              {' '}
            </span>
          )}
          <span className="quick-search__list-item-label">
            <HighlightMatch text={label} query={query} />
          </span>
        </div>
        {displayType && (
          <span className="quick-search__list-item-type">
            {result.type === 'subdepartment' ? t('quick-search.type-subdepartment') : t('quick-search.type-family')}
          </span>
        )}
      </button>
      {displayMode === 'inline-pipe' && !isLastItem && (
        <VpDivider orientation="vertical" />
      )}
    </>
  )
}
